module.exports = __webpack_public_path__ + "static/media/Winklerhotels.a8d17d36.jpg";